import { render } from "./PersonalInfoComponent.vue?vue&type=template&id=8a724684&scoped=true"
import script from "./PersonalInfoComponent.vue?vue&type=script&lang=js"
export * from "./PersonalInfoComponent.vue?vue&type=script&lang=js"

import "./PersonalInfoComponent.vue?vue&type=style&index=0&id=8a724684&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a724684"]])

export default __exports__